import { ReactElement } from 'react';

import { BodilColor } from '~src/branding';
import { TextButton } from '~src/components/TextButton';

type TextButtonWithIconProps = { buttonText?: string; onClick?: () => void; icon: ReactElement };

export const TextButtonWithIcon = ({ buttonText = 'Se alle beregninger', onClick, icon }: TextButtonWithIconProps) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '8px 0',
      }}
    >
      <TextButton color={BodilColor.base.white} textDecoration={'underline'} onClick={() => onClick?.()}>
        {buttonText}
      </TextButton>

      {icon}
    </div>
  );
};
